import Backbone from 'backbone';
import Cache from 'root/cache';

var Workflow = Backbone.Model.extend({
    defaults: {
        account_id       : 0,
        project_id       : 0,
        name             : '',
        sort             : 0,
        colour           : '',
        portal_status_id : 0
    },

    isResolved: function() {
        // Get the last model in the collection
        var current_project_workflow = Cache.workflow.where({project_id: this.get('project_id')});

        // find the largest sort
        var last_model = current_project_workflow.reduce(function(memo, model) {
            const current_sort = model.get('sort');
            const current_id = model.get('id');
            const max_sort = memo.get('sort');
            const max_id = memo.get('id');

            if (current_sort > max_sort || (current_sort === max_sort && current_id > max_id)) {
                return model;
            }

            return memo;
        });

        return last_model.get('id') === this.get('id');
    },
});

export default Workflow;